
import React from "react";
import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

const TikTokIconSvg = () => (
  <svg width="1em" height="1em" viewBox="0 0 13 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_2481_24888)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.32025 0.94043C9.55611 2.9703 10.6882 4.18049 12.6565 4.30924V6.5923C11.5158 6.70388 10.5167 6.33052 9.35456 5.62672V9.89674C9.35456 15.3212 3.44534 17.0163 1.06965 13.1282C-0.456974 10.6263 0.477866 6.23611 5.37506 6.06016V8.46767C5.00198 8.52776 4.60317 8.62217 4.23867 8.74662C3.14945 9.11569 2.53194 9.80661 2.70347 11.0254C3.03367 13.36 7.31335 14.0509 6.95742 9.48905V0.944721H9.32025V0.94043Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_2481_24888">
        <rect width="12.2601" height="14.3035" fill="white" transform="translate(0.396484 0.94043)"/>
      </clipPath>
    </defs>
  </svg>
);

export const TikTokIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={TikTokIconSvg} {...props} />
);
